// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1eoFC","additionalInfo":"AgreementModal_additionalInfo__3mSEP"};